import React, { Component } from 'react';
import styled from 'styled-components'
import Header from './../../Resources/AppScreens/CommonComponents/Retail/Header.svg';
import Custom0 from './../../Resources/AppScreens/CommonComponents/Retail/Featured Books.svg';

import Custom1 from './../../Resources/AppScreens/CommonComponents/Retail/News.svg';
import Custom2 from './../../Resources/AppScreens/CommonComponents/Retail/Latest Releases.svg';
//import { ReactComponent as Custom3 } from './../../Resources/AppScreens/CommonComponents/Hospitality/Two Buttons.svg';
//import { ReactComponent as Custom4 } from './../../Resources/AppScreens/CommonComponents/Hospitality/Property Resources.svg';
import Footer from './../../Resources/AppScreens/CommonComponents/Retail/Bottom Navigation.svg';
import RetailComponents from '../../Resources/AppScreens/Preview-Features/Retail';

import {Container, ScrollableContent as _ScrollableContent} from './Common';

const ScrollableContent = styled(_ScrollableContent)`
    margin-top: 6px;
    &>* {
        margin-top: 5px;
    }
`;


const RetailPreview = ({ features }) => (<Container>
    <img src={Header} style={{width: "100%"} } />
    <ScrollableContent>
        <img src={Custom0} />
        <img src={Custom1} style={{marginTop: "4px"}} />
        <img src={Custom2} />
        {features && features.map(feature => RetailComponents[feature])}
    </ScrollableContent>
    <img src={Footer} style={{ marginBottom: "0px;", marginTop: "auto", width: "100%" }} />
</Container>);

export default RetailPreview;

